import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

export const showToast = ({ status, message, ...rest }) => {
  dispatch(
    openSnackbar({
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      open: true,
      variant: 'alert',
      transition: 'SlideLeft',
      alert: {
        color: status,
      },
      message,
      ...rest,
    }),
  );
};
